

	<div class="table-responsive design-table">
        <table class="table table-hover table-striped">
            <thead>
                <tr>
                    <th style="width:50px">Sr.No</th>
                    <th>Error</th>               
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let error of ImportErrorData;let i = index">
                    <td style="width:50px">{{i+1}}</td>
                    <td><span style="color: grey;">{{error}}</span></td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="ImportErrorData?.length === 0" class="no-record-found">No Records Found</div>
       
    </div>